Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCheckCircleFilledData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3e%3cpath d='M12 0a12 12 0 1012 12A12 12 0 0012 0zm5.71 9.71l-7 7a1 1 0 01-1.41 0l-4-4a1 1 0 010-1.41 1 1 0 011.42 0L10 14.6l6.3-6.31a1 1 0 011.41 0 1 1 0 010 1.42z' fill='currentColor'/%3e%3c/svg%3e",
  iconCheckCircleFilledWidth: 24,
  iconCheckCircleFilledHeight: 24
};